import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import '../../CSS/Global.css';
import { BlobWriter, ZipWriter,TextReader } from '@zip.js/zip.js';

const ExportCustomer = () => {
    const { isSidebarOpen } = useSidebar();
    const [isSpecificDateSelected, setIsSpecificDateSelected] = useState(false);
    const [fileFormat, setFileFormat] = useState("xlsx");
    const [password, setPassword] = useState("");
    const [invoiceData, setInvoiceData] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const url=process.env.REACT_APP_LINK
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh"));
   

    useEffect(() => {
        fetch(`${url}/api/customer/all/${isLoggedIn.user_id}`)
            .then(res => res.json())
            .then(data => setInvoiceData(data))
            .catch(err => console.error("Failed to fetch invoices:", err));
    }, []);

    const handleRadioChange = (e) => {
        setIsSpecificDateSelected(e.target.value === 'specificDate');
    };

    // const handleExport = () => {
    //     if (!fileFormat) return alert("Please select a file format.");
    //     if (!password) return alert("Please enter a file password.");
    //     if (invoiceData.length === 0) return alert("No invoice data found.");

    //     let filteredData = [...invoiceData];

    //     if (isSpecificDateSelected) {
    //         if (!startDate || !endDate) return alert("Please select both start and end dates.");

    //         filteredData = invoiceData.filter(inv => {
    //             const invoiceDate = new Date(inv.invoice_date);
    //             const start = new Date(startDate);
    //             const end = new Date(endDate);
    //             return invoiceDate >= start && invoiceDate <= end;
    //         });

    //         if (filteredData.length === 0) {
    //             return alert("No invoices found in the selected date range.");
    //         }
    //     }

    //     const cleanedData = filteredData.map(inv => ({
    //         "Invoice Date": inv.invoice_date,
    //         "Order Number": inv.order_number,
    //         "Customer Name": inv.customer_name,
    //         "Due Date": inv.due_date,
    //         "Grand Total": inv.grand_total,
    //         "Pending": inv.pending,
    //         "Status": inv.pending === 0
    //             ? "Paid"
    //             : inv.due_date < new Date().toISOString().split("T")[0]
    //                 ? "Overdue"
    //                 : "Pending"
    //     }));

    //     const worksheet = XLSX.utils.json_to_sheet(cleanedData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

    //     const fileName = `invoices_${new Date().getTime()}.${fileFormat}`;
    //     XLSX.writeFile(workbook, fileName); // 👈 downloads directly (no zip)
    // };

    const handleExport = async () => {
        if (!fileFormat) return alert("Please select a file format.");
        if (!password) return alert("Please enter a file password.");
        if (invoiceData.length === 0) return alert("No customer data found.");
    
        let filteredData = [...invoiceData];
    
        if (isSpecificDateSelected) {
            if (!startDate || !endDate) return alert("Please select both start and end dates.");
    
            filteredData = invoiceData.filter(inv => {
                const date = new Date(inv.createdAt);
                const start = new Date(startDate);
                const end = new Date(endDate);
                return date >= start && date <= end;
            });
    
            if (filteredData.length === 0) return alert("No customers found in selected date range.");
        }
    
        const cleanedData = filteredData.map(cust => ({
            "Customer Name": cust.customerName || "",
            "Display Name": cust.displayName || "",
            "Company Name": cust.companyName || "",
            "Email": cust.email || "",
            "Phone 1": cust.phone1 || "",
            "Phone 2": cust.phone2 || "",
            "Currency": cust.currency || "",
            "GST Number": cust.gstNumber || "",
            "PAN": cust.pan || "",
            "Place of Supply": cust.placeOfSupply || "",
            "Remarks": cust.remarks || "",
            "Billing Address": cust.billingAddress?.address || "",
            "Shipping Address": cust.shippingAddress?.address || "",
            "Status": cust.status || ""
        }));
    
        // Create Excel binary data
        const worksheet = XLSX.utils.json_to_sheet(cleanedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");
        const excelBinary = XLSX.write(workbook, {
            type: 'binary',
            bookType: 'xlsx'
        });
    
        // Convert binary string to Blob
        const buffer = new ArrayBuffer(excelBinary.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < excelBinary.length; i++) {
            view[i] = excelBinary.charCodeAt(i) & 0xFF;
        }
        const excelBlob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    
        // Zip it with password
        const zipWriter = new ZipWriter(new BlobWriter("application/zip"), {
            password,
            encryptionStrength: 3 // AES-256
        });
    
        const fileName = `customers_${Date.now()}.xlsx`;
    
        await zipWriter.add(fileName, excelBlob.stream());
        const zipBlob = await zipWriter.close();
    
        // Trigger download
        const downloadUrl = URL.createObjectURL(zipBlob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = `${fileName}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(downloadUrl);
    };
   return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="export-card">
                    {/* Export Options */}
                    <div className="export-radio">
                        <div className="export-radio-list">
                            <input type="radio" name="exportOption" value="allCustomers" checked={!isSpecificDateSelected} onChange={handleRadioChange} />
                            <label>All Customers</label>
                        </div>
                        <div className="export-radio-list">
                            <input type="radio" name="exportOption" value="specificDate" checked={isSpecificDateSelected} onChange={handleRadioChange} />
                            <label>Specific Date</label>
                        </div>
                    </div>

                    {isSpecificDateSelected && (
                        <div className="date-range">
                            <div className="date-range-list">
                                <label>Start Date:</label>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </div>
                            <div className="date-range-list">
                                <label>End Date:</label>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </div>
                        </div>

                    )}

                    {/* Format selection */}
                    <div className="export-file-type">
                        <p className="export-file-header">Select file format:</p>
                        <div className="export-file-options">
                            {["csv", "xls", "xlsx"].map(fmt => (
                                <div className="export-file-option-list" key={fmt}>
                                    <input type="radio" name="fileFormat" id={fmt} value={fmt} onChange={e => setFileFormat(e.target.value)} />
                                    <label htmlFor={fmt}>{fmt.toUpperCase()}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Password input */}
                    <div className="file-password">
                        <p className="file-password-header">File Password:</p>
                        <input type="password" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>

                    {/* Export Buttons */}
                    <div className="export-buttons">
                        <button className="export-button" type="button" onClick={handleExport}>Export</button>
                        <button className="export-cancel-button" type="button">Cancel</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExportCustomer;
